<web-design-system-modal [headline]="'trade.multi-order.consent.' + type + '.headline' | transloco" [dismissable]="false">
  <p>{{ 'trade.multi-order.consent.' + type + '.text' | transloco }}</p>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <web-design-system-button (click)="confirm()">{{ 'trade.multi-order.consent.btn' | transloco }}</web-design-system-button>
    </div>
  </div>
</web-design-system-modal>
